import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b3f869c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "requirements mb-1" }

import { ref } from 'vue'
import { useRoute } from 'vue-router'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { Password } from '@/popup/components/shared/Form/Form'

type Emits = {
  (event: 'update-password', value: string, isPassed: boolean): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmPassword',
  emits: ["update-password"],
  setup(__props, { emit: __emit }) {

const route = useRoute()

const emits = __emit

const password = ref('')
const isPassed = ref(false)

const onPasswordChange = () => {
  isPassed.value = (route.query['password'] as string) === password.value
  emits('update-password', password.value, isPassed.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Password), {
      password: password.value,
      "onUpdate:password": [
        _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
        onPasswordChange
      ],
      "hide-errors": "",
      autofocus: true,
      autocomplete: "new-password",
      class: "mb-4"
    }, null, 8 /* PROPS */, ["password"]),
    _createElementVNode("div", {
      class: _normalizeClass([password.value ? 'show' : '', "wrapper"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (isPassed.value)
              ? (_openBlock(), _createBlock(SvgIcon, {
                  key: 0,
                  class: "mr-2",
                  color: "var(--green-54)",
                  name: "complete",
                  height: "16",
                  width: "16"
                }))
              : (_openBlock(), _createBlock(SvgIcon, {
                  key: 1,
                  class: "mr-2",
                  "secondary-color": "var(--neutral-100)",
                  color: "var(--neutral-75)",
                  name: "cross-outline",
                  height: "16",
                  width: "16"
                }))
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("p", {
          class: _normalizeClass(isPassed.value ? '' : 'grey')
        }, _toDisplayString(_ctx.$t('create_new_account.must_match')), 3 /* TEXT, CLASS */)
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})